export const FETCH_QUESTIONS = 'fetchQuestions'
export const INCREMENT_QUESTION = 'incrementQuestions'
export const RESET_PROGRESS = 'resetProgress'
export const RESET_QUESTION = 'resetQuestion'

export const UPDATE_USER = 'updateUser'
export const CREATE_USER = 'createUser'
export const INCREMENT_SCORE_USER = 'incrementScoreUser'
export const PROGRESS_USER = 'progressUser'
export const UPDATE_USER_QUESTIONS = 'updateUserQuestions'
export const RESET_USER = 'resetUser'
export const EXIST_USER = 'existUser'

export const UPDATE_ICONS = 'updateIcons'

export const SHOW_MODAL = 'showModal'
export const HIDE_MODAL = 'hideModal'

export const SHOW_PAGE = 'showPage'



// WEBPACK FOOTER //
// ./src/actions/index.js